import { builderCopy } from "./copy";
import type { DraftSnapshot } from "./draftSession";

/** Where the builder's header says whether the dial is saved (KEY-560). A refusal shows the server's own sentence. */
export function SavedIndicator({ snapshot, onRetry }: { snapshot: DraftSnapshot; onRetry: () => void }) {
  switch (snapshot.saveState) {
    case "saving":
      return <>{builderCopy.frame.saving}</>;
    case "saved":
      return <>{builderCopy.frame.saved}</>;
    case "paused":
      return <span className="kd-builder-save-problem">{snapshot.message || builderCopy.frame.notSaved}</span>;
    case "error":
      return (
        <span className="kd-builder-save-problem">
          {builderCopy.frame.notSaved}{" "}
          <button type="button" className="kd-builder-link" onClick={onRetry}>
            {builderCopy.frame.tryAgain}
          </button>
        </span>
      );
    default:
      return null;
  }
}
